<template>
    <div class="shortmessageindex">
        <div class="top">
            <el-col :span="19">
                <el-button type="primary" size="medium" @click="jumpToPage('abcActivityAddEdit')">发布活动</el-button>
            </el-col>
            <el-col :span="5">
                <el-input size="medium"  placeholder="请输入活动名称" v-model.trim="listQuery.title" @change="handleFilter">
                    <el-button size="medium" slot="append" icon="el-icon-search" @click="handleFilter"></el-button>
                </el-input>
            </el-col>
        </div>
        <el-table stripe :data="dataList"  :height="`${windowHeight-220}px`" border style="width: 100%" >
            <el-table-column  label="活动名称" show-overflow-tooltip  >
                <template slot-scope="scope">
                    {{scope.row.title}}
                </template>
            </el-table-column>
            <el-table-column label="活动区域" align="center">
                <template slot-scope="scope">
                    {{scope.row.orgAreaName}}
                </template>
            </el-table-column>
            <el-table-column label="活动链接" align="center">
                <template slot-scope="scope">
                    {{scope.row.url}}
                </template>
            </el-table-column>
            <el-table-column label="发布时间" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    {{scope.row.createTime| timeSuffixFilter}}
                </template>
            </el-table-column>
            <el-table-column label="状态" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    <el-tag size="mini" type="success" v-if="scope.row.state == 1">上架</el-tag>
                    <el-tag size="mini" type="danger" v-if="scope.row.state == 2">下架</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200">
                <template slot-scope="scope">
                    <el-button  @click.native.prevent="jumpToPage('abcActivityAddEdit', {id: scope.row.id})"  type="text" size="small">编辑</el-button>
                    <el-button  @click.native.prevent="changeStateFunc(scope.row, 2)"  type="text" size="small" v-if="scope.row.state == 1">下架</el-button>
                    <el-button  @click.native.prevent="changeStateFunc(scope.row, 1)"  type="text" size="small" v-if="scope.row.state == 2">上架</el-button>
                    <el-button  @click.native.prevent="deleteFunc(scope.row)"  type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="pagination-container"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNo"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>
    import {
        getAbcActivitySetListPage,
        updateAbcActivitySet,
        delAbcActivitySet
    } from '@/api/abcActivityManagement';
    import mixin from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';
    export default {
        data() {
            return {
                listQuery: {
                    pageNo: 1,
                    pageSize: 20,
                    title: "",
                    orgAreaCode:"",
                    state: 0
                },
                dataList: [],
                total: null,
                dialogVisible:false,
                myobj:{
                    id:"",
                    peopleCount:"",
                    price:""
                },
            }
        },
        created() {
            this.getList();
        },
        mixins: [mixin, baseMixin],
        methods: {
            //获取列表
            getList() {
                setTimeout(() => {
                    getAbcActivitySetListPage(this.listQuery)
                        .then(res => res.data)
                        .then(data => {
                            this.dataList = data.data.dataList;
                            this.total = data.data.pagination.total;
                        }).catch(err => {
                    })
                }, 100);

            },
            //搜索
            handleFilter (){
                this.listQuery.pageNo = 1 ;
                this.getList();
            },
            //切换码数
            handleSizeChange(val) {
                this.listQuery.pageNo=1;
                this.listQuery.pageSize = val;
                this.getList();
            },
            //切换页数
            handleCurrentChange(val) {
                this.listQuery.pageNo = val;
                this.getList();
            },
            deleteFunc(item){
                this.$confirm("确认要删除吗？", "删除", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                }).then(() => {
                    delAbcActivitySet({
                        abcActivitySetId: item.id
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message.success('删除成功');
                                this.getList();
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                });
            },
            changeStateFunc(item, state) {
                this.$confirm(`确认要${state == 2 ? '下架' : '上架'}吗？`, state == 2 ? '下架' : '上架', {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                }).then(() => {
                    updateAbcActivitySet({
                        id: item.id,
                        state
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message.success(`${state == 2 ? '下架' : '上架'}成功`);
                                this.getList();
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                });

            },
        }
    }
</script>
<style lang="scss" scoped>
    .shortmessageindex{
        padding:12px;
        .pagination-container {
            margin-top: 10px;
        }
        .top{
            padding-bottom: 10px;
            overflow: hidden;
        }
        .img{
            width: 30px;
            height: 30px;
        }
        .link-type{
            cursor: pointer;
            color: #409eff;
        }
        .red{
            color:#F56C6C;
        }
        .top-box{
            width: 100%;
            height: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/abcActivityManagement/abcActivityList.vue